<template>
	<v-autocomplete
		v-model="localValue"
		class="form__field"
		:items="augmentedOptions"
		:rules="validationRules"
		:label="label"
		:multiple="multiple"
		no-data-text="no matches found, press enter to create."
		@keyup.enter="addOption"
		@update:searchInput="searchInput = $event"
	>
		<template slot="no-data">
			<v-list-tile @click="addOption">
				<v-list-tile-title>
					{{ $t("addOptionHeader") }}
					<v-icon class="contact__autocomplete"
						>add</v-icon
					>
				</v-list-tile-title>
			</v-list-tile>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	props: {
		value: [ String, Array ],
		label: String,
		options: Array,
		required: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			searchInput: '',
			userOptions: [],
		}
	},
	computed: {
		augmentedOptions() {
			return [
				{ header: this.$t("addOptionHeader") },
				...this.options,
				...this.userOptions.length > 0 ? [ { header: this.$t("otherHeader") } ] : [],
				...this.userOptions,
			]
		},
		validationRules() {
			return this.required ? [v => !!v || this.$t("isRequired", { label: this.label })] : []
		},
		localValue: {
			get() {return this.value},
			set(localValue) { this.$emit('input', localValue)}
        },
	},
	created() {
		if (!this.value) return;

		const values = this.multiple ? this.value : [ this.value ]
		for (const value of values) {
			if (!this.options.find(option => option.value === value)) {
				const newOption = {
					text: value,
					value: value
				}
				this.userOptions.push(newOption)
			}
		}
	},
	methods: {
		addOption() {
			const newOption = {
				text: this.searchInput,
				value: this.searchInput
			}
			this.userOptions.push(this.searchInput);
			this.$emit(this.searchInput)
		},
	},
	i18n: {
		messages: {
			en: {
				addOptionHeader: "If your answer is missing, type to add it",
				isRequired: "{label} is a required field",
				otherHeader: "Other"
			},
			nl: {
				addOptionHeader: "Als uw antwoord hieronder niet is genoemd, type deze dan in:",
				isRequired: "{label} is een verplicht veld",
				otherHeader: "Overige"
			}
		}
	}

}
</script>
